import type { BookingAutomationTimelineEvent } from "../hooks/useBookingAutomationTimeline";

export function formatAutomationTimelineTitle(
  event: BookingAutomationTimelineEvent,
  automationLabel: string
): string {
  const target = event.new_status ?? "customs_cleared";
  switch (event.outcome) {
    case "updated":
      return `Status set to ${target.replace(/_/g, " ")}`;
    case "would_update":
      return `Would set status to ${target.replace(/_/g, " ")} (dry run)`;
    case "error":
      return "Automation check failed";
    default:
      return automationLabel;
  }
}

export function formatAutomationTimelineDescription(
  event: BookingAutomationTimelineEvent,
  automationLabel: string
): string {
  const parts: string[] = [automationLabel];
  if (event.previous_status && event.new_status) {
    parts.push(`${event.previous_status} → ${event.new_status}`);
  }
  if (event.has_utb != null || event.has_ttw != null) {
    parts.push(
      `UTB: ${event.has_utb ? "Yes" : "No"}, TTW: ${event.has_ttw ? "Yes" : "No"}`
    );
  }
  if (event.document_count != null) {
    parts.push(`${event.document_count} declaration document(s)`);
  }
  if (event.error_message) {
    parts.push(event.error_message);
  }
  return parts.join(" · ");
}

export function isAutomaticAutomationOutcome(outcome: string): boolean {
  return outcome === "updated" || outcome === "would_update";
}
